"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _localization = require("@lt/localization");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HotelCardFact = _interopRequireDefault(require("./HotelCardFact"));
var _HotelBeachDistance = _interopRequireDefault(require("../../icons-react/hotel-facts/HotelBeachDistance"));
var _userflow = require("../../utils/userflow");
var TOOLTIP = _localization.i18n.t('hotelcard.facts.beach.tooltip');
var LABEL = _localization.i18n.t('hotelcard.facts.beach.label');
var HotelBeachDistance = function HotelBeachDistance(_ref) {
  var value = _ref.value,
    className = _ref.className;
  return value ? /*#__PURE__*/_react["default"].createElement(_HotelCardFact["default"], {
    className: className,
    tooltip: TOOLTIP,
    label: LABEL,
    icon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledDistanceIcon, null), /*#__PURE__*/_react["default"].createElement(StyledLabel, null, (0, _userflow.formatDistance)(value)))
  }) : null;
};
var StyledLabel = _styledComponents["default"].span.withConfig({
  displayName: "HotelBeachDistance__StyledLabel",
  componentId: "sc-boakik-0"
})(["padding-bottom:5px;"]);
var StyledDistanceIcon = (0, _styledComponents["default"])(_HotelBeachDistance["default"]).withConfig({
  displayName: "HotelBeachDistance__StyledDistanceIcon",
  componentId: "sc-boakik-1"
})(["padding:0 2px;"]);
HotelBeachDistance.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].number
};
HotelBeachDistance.defaultProps = {
  className: '',
  value: null
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelBeachDistance);